
const com8E = {
	length: { min: 10, max: 10 },
	payload: [
		{ length: 1, name: "código", type: "bytes", description: "Código de configuración (1 byte).", pad: "00" },
		{ name: "URL", description: "Ruta para la descarga del firmware. Ejemplo: 'https://solxfirmwareupdates.blob.core.windows.net/miniq2-4g/…'", type: "string" },
		{ length: 9, name: "End_date", description: "Segundos desde 01/01/2000 (UTC). Tamaño: 9 bytes.", type: "bytes" },
	],
};

export default com8E;